import { CoursePageLayout } from "../courseBlocks";
import { mathMenuData } from "../../../data/SubjectMenu/mathMenuData";
import { mathsImg } from "../../../data/SubjectContent/maths/img";
import { mathsObjectivesBlocks } from "../../../data/SubjectContent/maths/objectives";

export function PageMathsObjectives() {
    return (
        <CoursePageLayout
            title="數學科 | 課程目標"
            subtitle="CURRICULUM OBJECTIVES"
            menuData={mathMenuData}
            nowIndex={0}
            topImage={{ src: mathsImg.objectivesTop, imgHeight: "650px" }}
            blocks={mathsObjectivesBlocks}
        />
    );
}
